import { FeatureType } from '@fleet-pro/mobile-webview-api';

export type FeatureMatchType = 'all' | 'any';

const checkFeatures = (availableFeatures: Set<FeatureType>) => (feature: FeatureType) =>
    availableFeatures.has(feature);

export const hasFeatures = (
    availableFeatures: Set<FeatureType>,
    requiredFeatures: FeatureType[],
    featureType: FeatureMatchType = 'any'
) => {
    if (!availableFeatures.size || !requiredFeatures.length) {
        return false;
    }

    const featureCheckPredicate = checkFeatures(availableFeatures);

    if (featureType === 'all') {
        return requiredFeatures.every(featureCheckPredicate);
    }

    return requiredFeatures.some(featureCheckPredicate);
};
